module.exports = __webpack_public_path__ + "media/newstyle/images/img2-footer-es-358fdcdbe2984e1a9e79c4bd0ddd2553.svg";